import { computed } from "@ember/object";
import RestModel from "discourse/models/rest";
import { i18n } from "discourse-i18n";

export const MAX_MESSAGE_LENGTH = 500;

export default class PostActionType extends RestModel {
  @computed("name_key")
  get isIllegal() {
    return this.name_key === "illegal";
  }

  @computed()
  get translatedDescription() {
    if (this.system) {
      return i18n(`post.actions.by_you.${this.name_key}`);
    }
    return i18n(`post.actions.by_you.custom`, {
      custom: this.name,
    });
  }
}
